import { usePublishedBoxStore } from '@/entities/sets/publish';
import { Pagination } from '@/shared/ui';
import { byNumAsc } from '@/shared/utils/publish';
import {
    findUserName,
    findUserNum,
} from '@/widgets/report/phase2/report-contents/answer-section/model/table.mapper';
import { FC, useEffect, useState } from 'react';

interface ByClassStudentTableProps {
    data?: API.IntegPubStntList.Res;
    onDetailProps: (stntData: { claName: string; userId: string; name: string }) => void;
}

export const ByClassStudentTable: FC<ByClassStudentTableProps> = ({ data, onDetailProps }) => {
    const { searchPage, setSearchPage } = usePublishedBoxStore();
    const pageData = data?.page;

    const [sortList, setSortList] = useState<DATA.PublishStntListType[]>([]);

    useEffect(() => {
        if (data && data.publishList) {
            const stntList = data.publishList?.map((e) => {
                const id = e?.stdtUserIds?.split(',')[0];
                return {
                    ...e,
                    num: findUserNum(id) ?? 0,
                    flnm: findUserName(id) ? findUserName(id) : e.flnm,
                };
            });
            const _sortList = byNumAsc(stntList);
            setSortList(_sortList as DATA.PublishStntListType[]);
        }
    }, [data]);

    const goToPublisheBoxSelectedStnt = (item: DATA.PublishStntListType) => {
        setSearchPage(0);
        onDetailProps({ claName: item.claNm, userId: item.stdtUserIds, name: item.flnm! });
    };

    return (
        <div className="table-board // con-mt3">
            <div className="table-board__body table-style1">
                <table>
                    <colgroup>
                        <col style={{ width: '72px' }} />
                        <col />
                        <col style={{ width: '534px' }} />
                    </colgroup>
                    <thead>
                        <tr>
                            <th scope="col">NO</th>
                            <th scope="col">학생</th>
                            {/* <th scope="col">클래스</th> */}
                            <th scope="col">최근 제출한 평가</th>
                        </tr>
                    </thead>
                    <tbody className="align-center">
                        {sortList?.map((item, idx) => {
                            return (
                                <tr key={`class-list-row-${idx}`}>
                                    <td className="txt1">
                                        {pageData && pageData.number * 30 + idx + 1}
                                    </td>
                                    <td>
                                        <button
                                            type="button"
                                            className="link2"
                                            onClick={() => {
                                                goToPublisheBoxSelectedStnt(item);
                                            }}
                                        >
                                            {item.num === 0 ? '' : item.num + '번 '}
                                            {item.flnm ?? '-'}
                                        </button>
                                    </td>
                                    {/* <td className="align-left">{item.claNm}</td> */}
                                    <td className="align-left">{item.publishNm ?? '-'}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            <div className="table-board__footer">
                <Pagination
                    currentPage={searchPage}
                    totalPages={data?.page.totalPages!}
                    onChange={(page: number) => setSearchPage(page)}
                    pageBtnCount={10}
                />
            </div>
        </div>
    );
};
